export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--8-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--8-3!../../../node_modules/sass-loader/dist/cjs.js??ref--8-4!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditSinisterPackages.vue?vue&type=style&index=0&id=64d070ae&prod&lang=scss&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/EditSinisterPackages.vue?vue&type=style&index=0&id=64d070ae&prod&lang=scss&scoped=true
// module id = 2085
// module chunks = 31